import { actionTypes } from '../actions/songs-lists';
import { songsLists as defaultState } from './default.json';

const handlers = {
  [actionTypes.SONGS_LISTS_GET_ERROR]: (state, action) => ({
    ...state,
    error: action.error.message,
    inProgress: false,
  }),
  [actionTypes.SONGS_LISTS_GET_IN_PROGRESS]: state => ({
    ...state,
    error: null,
    inProgress: true,
  }),
  [actionTypes.SONGS_LISTS_GET_SUCCESS]: (state, action) => ({
    ...state,
    error: null,
    inProgress: false,
    results: action.results,
  }),
};

export default (state = defaultState, action) => {
  const handler = handlers[action.type];
  return handler ? handler(state, action) : state;
};
